
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/audience-overviews",
      function () {
        return require("private-next-pages/customer-studio/audience-overviews.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/audience-overviews"])
      });
    }
  